module.exports = __webpack_public_path__ + "img/Order-now.9dd7b00f.png";